<template>
  <div class="flex items-center px-1 text-xs" :class="NetQualityColor">
    <svg
      class="w-[18px] mr-3 fill-current"
      viewBox="0 0 18 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0313 0.764282V15H18V0.764282H14.0313ZM7.44766 5.85864V15H11.4165V5.85864H7.44766ZM0.864594 10.9531V15H4.83331V10.9531H0.864594Z"
      />
    </svg>
    {{ NetQuality }} / {{ NetQualityMax }}
  </div>
</template>

<script>
import { netQualityColor } from "@/utils/Utils.js";

export default {
  props: {
    config: Object,
  },
  computed: {
    NetQuality() {
      return this.config?.rcPlus?.status?.wireless_link.hasOwnProperty(
        "4g_gnd_quality"
      )
        ? this.config.rcPlus?.status?.wireless_link["4g_gnd_quality"]
        : ENV.NO_DATA;
    },

    NetQualityMax() {
      return this.config?.rcPlus?.status?.wireless_link.hasOwnProperty(
        "4g_quality"
      )
        ? this.config.rcPlus?.status?.wireless_link["4g_quality"]
        : ENV.NO_DATA;
    },

    NetQualityColor() {
      let color = this.config?.rcPlus?.status?.wireless_link.hasOwnProperty(
        "4g_gnd_quality"
      )
        ? netQualityColor(
            this.config.rcPlus?.status?.wireless_link["4g_gnd_quality"]
          )
        : "g3";

      return "text-" + color + " fill-" + color;
    },
  },
};
</script>
